// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34rB5","question":"styles_question__2xq0M","description":"styles_description__1zBR8"};